var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.88 18.9001C6.47 18.9001 6.13 18.5601 6.13 18.1501V16.0801C6.13 15.6701 6.47 15.3301 6.88 15.3301C7.29 15.3301 7.63 15.6701 7.63 16.0801V18.1501C7.63 18.5701 7.29 18.9001 6.88 18.9001Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.9C11.59 18.9 11.25 18.56 11.25 18.15V14C11.25 13.59 11.59 13.25 12 13.25C12.41 13.25 12.75 13.59 12.75 14V18.15C12.75 18.57 12.41 18.9 12 18.9Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.12 18.8999C16.71 18.8999 16.37 18.5599 16.37 18.1499V11.9299C16.37 11.5199 16.71 11.1799 17.12 11.1799C17.53 11.1799 17.87 11.5199 17.87 11.9299V18.1499C17.87 18.5699 17.54 18.8999 17.12 18.8999Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87995 13.1799C6.53995 13.1799 6.23995 12.9499 6.14995 12.6099C6.04995 12.2099 6.28995 11.7999 6.69995 11.6999C10.38 10.7799 13.62 8.76992 16.09 5.89992L16.55 5.35992C16.82 5.04992 17.29 5.00992 17.61 5.27992C17.92 5.54992 17.96 6.01992 17.69 6.33992L17.23 6.87992C14.56 9.99992 11.04 12.1699 7.05995 13.1599C6.99995 13.1799 6.93995 13.1799 6.87995 13.1799Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1199 9.5201C16.7099 9.5201 16.3699 9.1801 16.3699 8.7701V6.6001H14.1899C13.7799 6.6001 13.4399 6.2601 13.4399 5.8501C13.4399 5.4401 13.7799 5.1001 14.1899 5.1001H17.1199C17.5299 5.1001 17.8699 5.4401 17.8699 5.8501V8.7801C17.8699 9.1901 17.5399 9.5201 17.1199 9.5201Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.4a00c5a3c8935256dd57edf950e35528.svg";
export { ForwardRef as ReactComponent };